<script setup lang="ts">
defineProps<{
  modelValue: string;
  options: ReadonlyArray<{ label: string; value: string }>;
}>();

defineEmits<{
  'update:modelValue': [value: string];
}>();
</script>

<template>
  <div class="flex gap-1">
    <button
      v-for="opt in options"
      :key="opt.value"
      class="px-2.5 py-1 text-[10px] font-black uppercase tracking-wider rounded-md cursor-pointer border-none transition-colors"
      :class="
        modelValue === opt.value
          ? 'bg-election-brand text-on-election-brand'
          : 'bg-surface-200/50 text-muted-color hover:text-on-surface'
      "
      @click="$emit('update:modelValue', opt.value)"
    >
      {{ opt.label }}
    </button>
  </div>
</template>
